import { render, staticRenderFns } from "./NotesActions.vue?vue&type=template&id=104e7060"
import script from "./NotesActions.vue?vue&type=script&lang=js"
export * from "./NotesActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports